class pageConstants {
  static LandingPage = "LandingPage";
  static CampaignPage = "CampaignPage";
  static DocCenterPage = "DocCenterPage";
  static BrokerComPage = "BrokerComPage";
  static CategoriesPage = "CategoriesPage";
  static SubCategoriesPage = "SubCategoriesPage";
  static EventCalendarPage = "EventCalendarPage";
  static QuickLinksPage = "QuickLinksPage";
  static CreateCampaignPage = "CreateCampaignPage";
  static CreateDocCenterPage = "CreateDocCenterPage";
  static EditCampaignPage = "EditCampaignPage";
  static EditDocumentPage = "EditDocumentPage";
  static ViewDocumentPage = "ViewDocumentPage";
  static CampaignDetailPage = "CampaignDetailPage";
}

export default pageConstants;
